import PhoneIcon from 'src/assets/icons/fi-rr-phone-call.svg';
import { FieldMappingsMockUpType } from '../types';

export const selectedData = {
  value: '',
  to_crm_if_blank: true,
  from_sprouts: false,
  nosync: false,
  // crm to sproutes
  toSprouts: true,
  dontSyncToSprouts: false,
};

export const selectedDataNew = {
  value: '',
  to_crm_if_blank: false,
  from_sprouts: true,
  nosync: false,
  // crm to sproutes
  toSprouts: false,
  dontSyncToSprouts: false,
};

export const CallFieldMappings: FieldMappingsMockUpType = {
  id: 'call',
  label: 'Call',
  testRunId: 'calls',
  testRunLabel: 'Calls',
  icon: PhoneIcon,
  desc: 'Fields mapped',
  count: '0',
  entity: 'Calls',
  sproutsFields: [
    {
      label: 'CMP ID',
      id: 'cmpId',
      selectedData,
      required: true,
      onlyOutbound: false,
    },
    {
      label: 'Record Call SID',
      id: 'recordCallSid',
      selectedData,
      onlyOutbound: false,
    },
    {
      label: 'Owner ID',
      id: 'ownerId',
      selectedData,
      required: true,
      onlyOutbound: false,
    },
    {
      label: 'Subject',
      id: 'subject',
      selectedData,
      onlyOutbound: false,
    },
    {
      label: 'Contact ID',
      id: 'contactId',
      selectedData,
      required: true,
      onlyOutbound: false,
    },
    // {
    //   label: 'Account ID',
    //   id: 'accountId',
    //   selectedData,
    //   onlyOutbound:false,
    // },
    {
      label: 'Start Date',
      id: 'startDate',
      selectedData,
      onlyOutbound: false,
    },
    // {
    //   label: 'Duration',
    //   id: 'duration',
    //   selectedData,
    //   onlyOutbound:false,
    // },
    {
      label: 'Status',
      id: 'status',
      selectedData,
      onlyOutbound: false,
    },
    {
      label: 'Resolution',
      id: 'resolution',
      selectedData,
      onlyOutbound: false,
    },
    {
      label: 'Call Type',
      id: 'callType',
      selectedData,
      onlyOutbound: false,
    },
    // {
    //   label: 'Custom Call Resolution ID',
    //   id: 'customCallResolutionId',
    //   selectedData,
    //   onlyOutbound:false,
    // },
    {
      label: 'Notes',
      id: 'notes',
      selectedData,
      onlyOutbound: false,
    },
    {
      label: 'Sequence ID',
      id: 'sequenceId',
      selectedData,
      onlyOutbound: false,
    },
    {
      label: 'Step ID',
      id: 'stepId',
      selectedData,
      onlyOutbound: false,
    },
  ],
};
// Microsoft Dynamics specific call field mappings (same fields as Salesforce, but inbound enabled)
export const CallFieldMappingsMicrosoft: FieldMappingsMockUpType = {
  id: 'call',
  label: 'Call',
  testRunId: 'calls',
  testRunLabel: 'Calls',
  icon: PhoneIcon,
  desc: 'Fields mapped',
  count: '0',
  entity: 'Calls',
  sproutsFields: [
    {
      label: 'Call Subject',
      id: 'subject',
      selectedData: selectedData,
      onlyOutbound: false,
      disableToCrmIfBlank: true,
      required: true,
    },
    {
      label: 'Call Notes',
      id: 'notes',
      selectedData: selectedData,
      onlyOutbound: false,
      disableToCrmIfBlank: true,
      required: true,
    },
    {
      label: 'Task SubType',
      id: 'callSubType',
      selectedData: selectedData,
      onlyOutbound: false,
      disableToCrmIfBlank: true,
      required: true,
    },
    {
      label: 'Sequence Name',
      id: 'sequenceName',
      selectedData: selectedData,
      onlyOutbound: true,
      disableToCrmIfBlank: true,
    },
    {
      label: 'Step Number',
      id: 'stepNumber',
      selectedData: selectedData,
      onlyOutbound: true,
      disableToCrmIfBlank: true,
    },
    {
      label: 'Activity Time',
      id: 'startDate',
      selectedData: selectedData,
      onlyOutbound: false,
      disableToCrmIfBlank: true,
    },
    {
      label: 'Activity Time (Prospect Local Time)',
      id: 'convertedStartDate',
      selectedData: selectedData,
      onlyOutbound: true,
      disableToCrmIfBlank: true,
    },
    {
      label: 'Prospect Timezone',
      id: 'timezone',
      selectedData: selectedData,
      onlyOutbound: true,
      disableToCrmIfBlank: true,
    },
    {
      label: 'Call Type',
      id: 'callType',
      selectedData: selectedData,
      onlyOutbound: false,
      disableToCrmIfBlank: true,
    },
    {
      label: 'Call Disposition',
      id: 'status',
      selectedData: selectedData,
      onlyOutbound: false,
      disableToCrmIfBlank: true,
    },
    {
      label: 'Call Resolution',
      id: 'customCallResolutionName',
      selectedData: selectedData,
      onlyOutbound: false,
      disableToCrmIfBlank: true,
    },
    {
      label: 'Call Duration',
      id: 'duration',
      selectedData: selectedData,
      onlyOutbound: false,
      disableToCrmIfBlank: true,
    },
  ],
};

// Expanded activity call field mappings
export const CallFieldMappingsExpandedActivity: FieldMappingsMockUpType = {
  id: 'call',
  label: 'Call',
  testRunId: 'calls',
  testRunLabel: 'Calls',
  icon: PhoneIcon,
  desc: 'Fields mapped',
  count: '0',
  entity: 'Calls',
  sproutsFields: [
    {
      label: 'Call Subject',
      id: 'subject',
      selectedData: selectedDataNew,
      onlyOutbound: true,
      disableToCrmIfBlank: true,
      required: true,
    },
    {
      label: 'Call Notes',
      id: 'notes',
      selectedData: selectedDataNew,
      onlyOutbound: true,
      disableToCrmIfBlank: true,
      required: true,
    },
    // {
    //   label: 'Status',
    //   id: 'status',
    //   selectedData: selectedDataNew,
    //   onlyOutbound: true,
    //   disableToCrmIfBlank: true,
    //   supportedTypes: ['Object','String'],
    //   required:true
    // },
    // {
    //   label: 'Task Type',
    //   id: 'type',
    //   selectedData,
    //   onlyOutbound: true,
    //   disableToCrmIfBlank: true,
    // },
    {
      label: 'Task SubType',
      id: 'callSubType',
      selectedData: selectedDataNew,
      onlyOutbound: true,
      disableToCrmIfBlank: true,
      required: true,
    },
    {
      label: 'Sequence Name',
      id: 'sequenceName',
      selectedData: selectedDataNew,
      onlyOutbound: true,
      disableToCrmIfBlank: true,
    },
    {
      label: 'Step Number',
      id: 'stepNumber',
      selectedData: selectedDataNew,
      onlyOutbound: true,
      disableToCrmIfBlank: true,
    },
    {
      label: 'Activity Time',
      id: 'startDate',
      selectedData: selectedDataNew,
      onlyOutbound: true,
      disableToCrmIfBlank: true,
    },
    {
      label: 'Activity Time (Prospect Local Time)',
      id: 'convertedStartDate',
      selectedData: selectedDataNew,
      onlyOutbound: true,
      disableToCrmIfBlank: true,
    },
    {
      label: 'Prospect Timezone',
      id: 'timezone',
      selectedData: selectedDataNew,
      onlyOutbound: true,
      disableToCrmIfBlank: true,
    },
    {
      label: 'Call Type',
      id: 'callType',
      selectedData: selectedDataNew,
      onlyOutbound: true,
      disableToCrmIfBlank: true,
    },
    {
      label: 'Call Disposition',
      id: 'status',
      selectedData: selectedDataNew,
      onlyOutbound: true,
      disableToCrmIfBlank: true,
    },
    {
      label: 'Call Resolution',
      id: 'customCallResolutionName',
      selectedData: selectedDataNew,
      onlyOutbound: true,
      disableToCrmIfBlank: true,
    },
    {
      label: 'Call Duration',
      id: 'duration',
      selectedData: selectedDataNew,
      onlyOutbound: true,
      disableToCrmIfBlank: true,
    },
  ],
};
